import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { AcademyEmptyState } from '../../AcademyEmptyState/AcademyEmptyState';

export type ErrorPageProps = {
  error: Error | string;
  onRetry?: () => void;
};

export const ErrorPage = ({ error, onRetry }: Readonly<ErrorPageProps>) => {
  const message = typeof error === 'string' ? error : error?.message;

  return (
    <Box sx={{ py: 4 }}>
      <AcademyEmptyState variant="error" onRetry={onRetry} />
      {message && (
        <Typography
          variant="body1"
          color="text.disabled"
          sx={{ display: 'block', textAlign: 'center', mt: 1, px: 4 }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};
